import { useState, useEffect } from 'react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { Button, Select, Box } from '@material-ui/core';
import { zonedTimeToUtc } from 'date-fns-tz';
import { addMinutes, set } from 'date-fns';
import timezones from 'timezones-list';
import { AllTimeZone } from '../utils/timezone';
import moment from 'moment';
import DateRangeOptionButtonGroup from '../components/DateRangeOptionButtonGroup';
import { defaultRanges } from '../utils/datetime';

const DateRangePickerBS = ({
  onChange,
  value,
  setMinDate = moment().subtract(3, 'months').toDate(),
  setMaxDate = moment().toDate(),
}) => {
  const [preset, setPreset] = useState({
    name: '(GMT+08:00) Singapore, Woodlands',
    data: {
      label: 'Asia/Singapore (GMT+08:00)',
      name: '(GMT+08:00) Singapore, Woodlands',
      tzCode: 'Asia/Singapore',
      utc: '+08:00',
    },
  });
  const [timeMode, setTimeMode] = useState('midday');
  const [state, setState] = useState([new DateObject(), new DateObject()]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTimeModeChange = (mode) => {
    setTimeMode(mode);

    const dropdownRange = defaultRanges(preset, mode);
    if (dropdownRange.length > 0) {
      onChange?.({ ...dropdownRange[0] });
      setState([
        new DateObject(dropdownRange[0].startDate),
        new DateObject(dropdownRange[0].endDate),
      ]);
    }
  };

  function createRange(item) {
    const startDate = item[0] instanceof Date ? item[0] : item[0].toDate();
    const endDate = item[1] instanceof Date ? item[1] : item[1].toDate();

    return {
      startDate,
      endDate,
      startDateValue: zonedTimeToUtc(moment(startDate).toDate(), preset?.data?.tzCode),
      endDateValue: zonedTimeToUtc(moment(endDate).toDate(), preset?.data?.tzCode),
      timezones: preset,
    };
  }

  useEffect(() => {
    return () => {};
  }, []);
  return (
    <>
      <Box display="flex" flexDirection="column">
        <Box display="flex" flexDirection="row" mt={1}>
          <Select
            native
            value={preset?.data.name}
            onChange={(event) => {
              const name = event.target.value;
              console.log(name);
              if (name) {
                const tz = timezones.find((elem) => elem.name == name);
                console.log('tz: ', tz);
                setPreset({ name: name, data: tz });
              } else {
                setPreset({ name: '', data: '' });
              }
            }}
            inputProps={{ name: 'name', id: 'preset' }}
            style={{ margin: '0 10px' }}
          >
            <option value="">Select Timezone</option>
            {AllTimeZone.map((v) => {
              return (
                <option value={v.value} key={v.name}>
                  {v.name}
                </option>
              );
            })}
          </Select>
          <DatePicker
            range
            dateSeparator=" - "
            highlightToday={false}
            value={state}
            maxDate={setMaxDate}
            minDate={setMinDate}
            onChange={setState}
            onClose={() => {
              if (state.length >= 1) {
                const startDate = set(state[0].toDate(), {
                  seconds: 0,
                  milliseconds: 0,
                });
                const endDate = set(state[state.length > 1 ? 1 : 0].toDate(), {
                  seconds: 0,
                  milliseconds: 0,
                });
                const range = createRange([startDate, endDate]);
                onChange(range);
              }
            }}
            format="YYYY-MM-DD HH:mm"
            plugins={[<TimePicker hideSeconds key="1" position="bottom" />]}
            render={(value, openCalendar) => {
              return (
                <Button
                  aria-describedby={id}
                  variant="contained"
                  color="secondary"
                  onClick={openCalendar}
                >
                  {value}
                  <DateRangeIcon />
                </Button>
              );
            }}
          />
        </Box>
      </Box>
      <Box display="flex" flexDirection="row" mt={1}>
        <Select
          native
          value={timeMode}
          onChange={(event) => {
            handleTimeModeChange(event.target.value);
          }}
          inputProps={{ name: 'name', id: 'timezone' }}
          style={{ margin: '0 10px' }}
        >
          <option value="midday">Midday (12:00 - 12:00)</option>
          <option value="midnight">Midnight (00:00 - 00:00)</option>
        </Select>
        <DateRangeOptionButtonGroup
          onChange={(value) => {
            onChange(value);
            setState([new DateObject(value.startDate), new DateObject(value.endDate)]);
          }}
          tz={preset}
          timeMode={timeMode}
        />
      </Box>
    </>
  );
};

export default DateRangePickerBS;
